<script setup lang="ts">
import type { Team } from "@/model/session";

defineProps<{ teams: Team[] }>();
</script>

<template>
  <div>{{ $t("general.teams") }}</div>
  <div v-for="team in teams" :key="team.id" class="shortcut">
    {{ team.name }}
  </div>
</template>
